function initTabbyPromotions() {
    var tabbyPromoEl = document.querySelector('#tabbyPromo');
    if (tabbyPromoEl) {
        var merchantCode = tabbyPromoEl.getAttribute('data-tabby-merchantCode');
        var publicKey = tabbyPromoEl.getAttribute('data-tabby-publicKey');
        var price = tabbyPromoEl.getAttribute('data-tabby-price');
        var currency = tabbyPromoEl.getAttribute('data-tabby-currency');
        var lang = tabbyPromoEl.getAttribute('data-tabby-lang');

        var tabbyConf = { "selector": "#tabbyPromo", "merchantCode": "AE", "publicKey": "", "lang": "en_US", "localeSource": "", "currency": "AED", "price": "79.00", "email": null, "phone": null, "source": "product", "theme": "", "installmentsCount": 4, "productType": "installments" };

        if (lang) {
            tabbyConf.lang = lang;
        }
        if (merchantCode) {
            tabbyConf.merchantCode = merchantCode;
        }
        if (publicKey) {
            tabbyConf.publicKey = publicKey;
        }
        if (price) {
            tabbyConf.price = price;
            tabbyConf.currency = currency;
        }
        if (tabbyConf.localeSource == 'html') tabbyConf.lang = document.documentElement.lang;
        var tabbyPromo;
        if (typeof TabbyPromo !== 'undefined') {
            tabbyPromo = new TabbyPromo(tabbyConf);
        }
        document.querySelectorAll('.tabbyPromo').forEach(tpromo => {
            let tabbyConfNew = { ...tabbyConf };
            tabbyConfNew.selector = '#' + tpromo.getAttribute('id');
            // console.log(tabbyConfNew);
            if (typeof TabbyPromo !== 'undefined') {
                new TabbyPromo(tabbyConfNew);
            }
        });
    }
}
if (typeof TabbyPromo == 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
        initTabbyPromotions();
    });
} else {
    initTabbyPromotions();
}
// addon for product variations
document.addEventListener('on:variant:change', (event) => {
    initTabbyPromotions();
});

if (!customElements.get('load-more-products')) {
    class LoadMoreProducts extends HTMLElement {
        connectedCallback() {
            this.page = 2;
            this.loadMoreButton = document.getElementById('load-more');
            this.init();
            this.addEventListener('click', this.handleClick.bind(this));
        }

        init() {
            const observer = new IntersectionObserver(this.revealItem.bind(this), {
                root: null,
                threshold: 0.05,
            });
            observer.observe(this);
        }

        revealItem(e, t) {
            const [i] = e;
            if (!i.isIntersecting) return;
            if (i.target) {
                this.page++;
                this.handleClick();
            }

            if (this.page == this.loadMoreButton.getAttribute('load-more-total-pages')) {
                t.unobserve(i.target);
            }
        }

        handleClick(evt) {
            // evt.preventDefault();
            // var loadMoreButton = evt.target;
            var loadMoreButton = this.loadMoreButton;
            var productGrid = document.getElementById('product-grid');
            var currentPage = this.page;
            var text = loadMoreButton.getAttribute('load-more-text');
            var loading = loadMoreButton.getAttribute('load-more-loading');
            var totalPages = loadMoreButton.getAttribute('load-more-total-pages');
            var currentUrl = loadMoreButton.getAttribute('load-more-next-url');
            if (currentUrl) {
                loadMoreButton.innerText = loading;
                loadMoreButton.setAttribute('disabled', 'disabled');
                var xhr = new XMLHttpRequest();
                xhr.open('GET', currentUrl, true);
                xhr.onload = function () {
                    if (xhr.status >= 200 && xhr.status < 400) {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(xhr.responseText, 'text/html');
                        var newProducts = doc.querySelectorAll('.product-block');

                        newProducts.forEach(function (product) {
                            productGrid.appendChild(product);
                        });
                        currentPage++;
                        console.log(currentPage);
                        console.log(totalPages);
                        if (currentPage <= totalPages) {
                            var currentPageNext = currentPage + 1;
                            loadMoreButton.setAttribute('load-more-next-url', currentUrl.replace('page=' + currentPage, 'page=' + currentPageNext));
                            loadMoreButton.innerText = text;
                            loadMoreButton.removeAttribute("disabled");
                        }
                        if (currentPage >= totalPages) {
                            loadMoreButton.style.display = 'none';
                        }
                    }
                };
                xhr.send();
            } else {
                loadMoreButton.style.display = 'none';
            }
        }
    }

    customElements.define('load-more-products', LoadMoreProducts);
}

class VariantPrice extends HTMLElement {
    constructor() {
        super();
        if (this.childElementCount > 0) {
            // document.addEventListener('DOMContentLoaded', this.handleVariantChange.bind(this));
            if (this.closest('.js-product')) this.closest('.js-product').addEventListener('on:variant:change', this.handleVariantChange.bind(this));
        }
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
        const PriceToShow = this.querySelector(`[data-variant="${evt.detail.variant ? evt.detail.variant.id : ''}"]`);
        if (PriceToShow) {
            PriceToShow.closest('.variant-price').querySelectorAll('.box-price').forEach((el) => el.classList.add('hidden'));
            PriceToShow.classList.remove('hidden');
        }
    }
}

customElements.define('variant-price', VariantPrice);

document.addEventListener('DOMContentLoaded', () => {
    initScrollToProductColorVariants();
});

function initScrollToProductColorVariants() {
    if (window.screen.width < 768) {
        if (localStorage.getItem('product_color_variants_target')) {
            var product_color_variants = document.querySelector('#product_color_variants');
            if (product_color_variants) {
                const ScrollToProductColorVariants = theme.getOffsetTopFromDoc(product_color_variants) - document.querySelector('.section-header').clientHeight;
                window.scrollTo({
                    top: localStorage.getItem('product_color_variants_target'), // ScrollToProductColorVariants
                    behavior: 'instant'
                });
                localStorage.removeItem('product_color_variants_target');
            }
        }
    } else {
        localStorage.removeItem('product_color_variants_target');
    }
}